if (!customElements.get('juronoid-contact-form')) {
  customElements.define('juronoid-contact-form', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const topics = [...this.querySelectorAll('[data-topic]')];
      const hints = [...this.querySelectorAll('[data-topic-hint]')];
      const orderField = this.querySelector('[data-order-field]');
      const body = this.querySelector('textarea');
      const counter = this.querySelector('[data-character-count]');
      const sync = () => {
        const selected = topics.find(input => input.checked)?.dataset.topic || 'other';
        hints.forEach(hint => { hint.hidden = hint.dataset.topicHint !== selected; });
        if (orderField) {
          orderField.hidden = selected !== 'shop';
          orderField.querySelector('input').disabled = selected !== 'shop';
        }
        if (counter && body) counter.textContent = `${body.value.length} / ${body.maxLength}`;
      };
      topics.forEach(input => input.addEventListener('change', sync, options));
      body?.addEventListener('input', sync, options);
      window.addEventListener('pageshow', sync, options);
      const requestedTopic = new URLSearchParams(location.search).get('topic');
      const requested = topics.find(input => input.dataset.topic === requestedTopic);
      if (requested && !this.querySelector('.jc-form-status, .jc-form-error')) requested.checked = true;
      if (counter) counter.hidden = false;
      sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.initialized = false;
    }
  });
}
if (!customElements.get('juronoid-collection-guide')) {
  customElements.define('juronoid-collection-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const stories = [...this.querySelectorAll('[data-story]')];
      const illustrations = [...this.querySelectorAll('[data-story-art]')];
      const sync = active => illustrations.forEach(item => { item.hidden = item.dataset.storyArt !== active.dataset.story; });
      stories.forEach(story => story.addEventListener('toggle', () => {
        if (!story.open) return;
        stories.forEach(other => { if (other !== story) other.open = false; });
        sync(story);
      }, options));
      const openHash = () => {
        let id;
        try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const match = stories.find(story => story.id === id);
        if (match) { match.open = true; sync(match); }
      };
      window.addEventListener('hashchange', openHash, options);
      window.addEventListener('pageshow', openHash, options);
      const active = stories.find(story => story.open);
      if (active) sync(active);
      openHash();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.initialized = false;
    }
  });
}
